export enum ToleranceType {
    With,
    Without
}
